import AxiosConfig from './LensAxiosConfig'
import firebase from '../config/FirebaseConfig'

const create = async (presetPayload) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/presets',
    presetPayload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const remove = async (presetId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.delete(
      `/presets/${presetId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
  )

  return data
}

const getByID = async (presetId) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    `/presets/v2/${presetId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const getAll = async (lensId = null) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser
  const params = new URLSearchParams()

  if (lensId) params.append('lens_id', lensId)

  const { data } = await AxiosConfig.get(
    `/presets/v2?${params.toString()}`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const update = async (presetId, payload) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.patch(
    `/presets/${presetId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}
export default {
  create,
  update,
  remove,
  getByID,
  getAll
}
